// extracted by mini-css-extract-plugin
module.exports = {"modalContent":"UpgradeEpcsModal_modalContent__2tZct","modalForm":"UpgradeEpcsModal_modalForm__3kETY","modalFooter":"UpgradeEpcsModal_modalFooter__34TS4"};